export default {
  0: '未清洗',
  1: '已清洗',
  2: '已拿回'
}



// WEBPACK FOOTER //
// ./src/js/ClotheStatus.js